import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=18b916cc&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b916cc')) {
      api.createRecord('18b916cc', component.options)
    } else {
      api.reload('18b916cc', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=18b916cc&", function () {
      api.rerender('18b916cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cm6A52qOq9HJ/JS/cancellationPolicy.vue"
export default component.exports